export const ADMIN = {
  emailInput: 'admin-email-input',
  passwordInput: 'admin-password-input',
  loginButton: 'admin-login-button',
  loginError: 'admin-login-error',
  logoutButton: 'admin-logout-button',
  navTestIds: 'admin-nav-test-ids',
  navSettings: 'admin-nav-settings',
  genSubscription: 'gen-subscription-select',
  genTestType: 'gen-test-type-select',
  genInstitution: 'gen-institution-input',
  genEmail: 'gen-candidate-email-input',
  genCount: 'gen-count-input',
  generateButton: 'generate-id-button',
  table: 'test-ids-table',
  tableRow: 'test-id-row',
  deleteButton: 'delete-test-id-button',
  confirmDelete: 'confirm-delete-button',
  settingsMsisInput: 'settings-msis-domainchoices-input',
  settingsMsosInput: 'settings-msos-domainchoices-input',
  settingsMsisSave: 'settings-msis-save-button',
  settingsMsosSave: 'settings-msos-save-button',
  navPricing: 'admin-nav-pricing',
  navOrders: 'admin-nav-orders',
  priceIndividualInr: 'price-individual-inr-input',
  priceIndividualUsd: 'price-individual-usd-input',
  priceInstitutionUsd: 'price-institution-usd-input',
  priceSlab: 'price-slab-input',
  pricingSave: 'pricing-save-button',
  ordersTable: 'orders-table',
};
